import React, { useEffect, useState } from 'react';
import { addSubCategoryApi, updateSubCategoryApi } from '../../../../api/subcategory';
import { getAccessTokenApi } from '../../../../api/auth';
import { errorModal, successModal, warningModal } from '../../../Alerts/Alerts';

export default function AddEditSubCatForm(props) {
    const { categories, 
            subCategories, 
            subCategoriesBase,
            setReloadCategories, 
            setReloadSubCategories,
            setReloadsubCategoriesBase,
            setReloadSubCategoriesDeta,
            setIsVisibleModal } = props;
    const [ subCatData, setSubCatData ] = useState({});

    useEffect(() => {
        if(subCategoriesBase){
            setSubCatData(subCategoriesBase);
        }else{
            setSubCatData({});
        }
    }, [subCategoriesBase]);

    const processPost = () => {
        if (!subCatData.nm_subcategoria) {
          warningModal("Advertencia", "Debe ingresar Nombre de Subcategoría.");
        } else {
          if (!subCategoriesBase) {
            addSubCategory();
          } else {
            updateSubCategory();
          }
        }
      };

    const addSubCategory = () => {

        subCatData.id_usuario = localStorage.getItem('id');

        if(!subCatData.id_categoria){
          if(categories){
            subCatData.id_categoria = categories[0]._id;
          }
        }
        const accessToken = getAccessTokenApi();
        addSubCategoryApi(accessToken, subCatData)
            .then(response => {
                switch (response.code) {
                  case 200:
                    setIsVisibleModal(false);
                    setSubCatData({});
                    setReloadSubCategories(true);
                    setReloadsubCategoriesBase(true);
                    setReloadSubCategoriesDeta(true)
                    successModal("", response.message);
                    break;
                  case 404:
                    warningModal("Advertencia", response.message);
                    break;
                  case 500:
                    setReloadSubCategoriesDeta(true);
                    errorModal("Advertencia", response.message);
                    break;
                  default:
                    break;
                }
            })
            .catch(err => {
                errorModal	("Error", err);
        });
    };

    const updateSubCategory = () => {

        subCatData.id_usuario = localStorage.getItem('id');

        if(!subCatData.id_categoria){
          if(categories){
            subCatData.id_categoria = categories[0]._id;
          }
        }

        const token = getAccessTokenApi();
        updateSubCategoryApi(token, subCatData._id, subCatData)
          .then(response => {
            setIsVisibleModal(false);
            switch (response.code) {
              case 200:
                setReloadSubCategoriesDeta(true);
                setSubCatData({});
                setReloadSubCategories(true);
                setReloadsubCategoriesBase(true);
                successModal("", response.message);
                break;
              case 404:
                warningModal("Advertencia", response.message);
                break;
              case 500:
                setReloadSubCategoriesDeta(true);
                errorModal("Advertencia", response.message);
                break;
              default:
                break;
            }
          })
          .catch(() => {
            errorModal	("Error", "Error del Servidor.");
          });
      };

    const closeModal = () => {
        setIsVisibleModal(false);
    }

    return (
        <div>
            <form>
                <div className="form-group">
                    <label>Nombre de Subcategoría</label>
                    <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Nombre de Subcategoría" 
                            value={subCatData.nm_subcategoria ? subCatData.nm_subcategoria : ''}
                            onChange={e => setSubCatData({ ...subCatData, nm_subcategoria: e.target.value })} />
                </div>
                <div className="form-group">
                    <Category 
                        categories={categories} 
                        setReloadCategories={setReloadCategories}
                        subCategories={subCategories}
                        setSubCatData={setSubCatData}
                        subCatData={subCatData}
                    />
                </div>
                <div className="modal-footer ">
                    <button className="btn btn-danger" type="button" data-dismiss="modal" onClick={closeModal} >Cancelar</button>
                    <button className="btn btn-success text-white" type="button" onClick={processPost}>Guardar</button>
                </div>
            </form>
        </div>
    )
}

function Category (props) {
    const { categories, setSubCatData, subCatData } = props;

    return(
        <>
            <label>Nivel de Categoría</label>
            <select 
                className="form-control"
                value={subCatData.id_categoria}
                onChange={e => setSubCatData({ ...subCatData, id_categoria: e.target.value })}
            >
                {categories && categories.map((cat, index) => (
                    <option key={index} value={cat._id}>{cat.nm_categoria}</option>
                ))}
            </select>
        </>
    )
}
